import { useUserStore } from '~/app/_store/user-store'

export const useIsBaseHubEmployee = () => {
  const optimisticUser = useUserStore((s) => s.optimisticUser)
  if (!optimisticUser?.email) return undefined
  return (
    optimisticUser.email.endsWith('@basehub.com') ||
    [
      'julianbenegas99@gmail.com',
      'moransantiago@gmail.com',
      'signorettafabrizio@gmail.com',
    ].includes(optimisticUser.email)
  )
}
